import { render, staticRenderFns } from "./MobileRecall.vue?vue&type=template&id=f85a7d86&scoped=true"
import script from "./MobileRecall.vue?vue&type=script&lang=js"
export * from "./MobileRecall.vue?vue&type=script&lang=js"
import style0 from "./MobileRecall.vue?vue&type=style&index=0&id=f85a7d86&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85a7d86",
  null
  
)

export default component.exports